import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useTranslation } from "react-i18next";
import Box from "../../../../Styled/Box";
import { RawButton } from "../../../../Styled/Button";
import Icon from "../../../../Styled/Icon";
import { TextSpan } from "../../../../Styled/Text";
import Ul, { Li } from "../../../../Styled/List";
import MenuPanel from "../../../StandardUserInterface/customizable/MenuPanel";
import Styles from "../../MenuBar/menu-bar.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const stripLangLocale = function () {
  let lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return lang.split("-")[0];
};
const LangPanel = props => {
  var _props$terria$configP;
  const {
    t,
    i18n
  } = useTranslation();
  if (!((_props$terria$configP = props.terria.configParameters.languageConfiguration) !== null && _props$terria$configP !== void 0 && _props$terria$configP.languages)) {
    return null;
  }
  return (
    /*#__PURE__*/
    //@ts-expect-error - not yet ready to tackle tsfying MenuPanel
    _jsx(MenuPanel, {
      theme: {
        btn: Styles.langBtn,
        icon: Icon.GLYPHS.globe
      },
      btnText: props.smallScreen ? t("languagePanel.changeLanguage") : stripLangLocale(i18n.language),
      mobileIcon: Icon.GLYPHS.globe,
      smallScreen: props.smallScreen,
      children: /*#__PURE__*/_jsx(Box, {
        paddedRatio: 3,
        children: /*#__PURE__*/_jsx(_StyledUl, {
          spaced: true,
          lined: true,
          fullWidth: true,
          column: true,
          children: Object.entries(props.terria.configParameters.languageConfiguration.languages).map(_ref => {
            let [key, value] = _ref;
            return /*#__PURE__*/_jsx(Li, {
              children: /*#__PURE__*/_jsx(RawButton, {
                onClick: () => i18n.changeLanguage(key),
                children: /*#__PURE__*/_jsx(TextSpan, {
                  isLink: true,
                  children: value
                })
              })
            }, key);
          })
        })
      })
    })
  );
};
export default LangPanel;
var _StyledUl = _styled(Ul).withConfig({
  displayName: "LangPanel___StyledUl",
  componentId: "sc-1sb31ji-0"
})(["padding-left:0;"]);